/**
 * Reçete durumu tedavi kaydından TÜRETİLİR — modelde ayrı bir alan yok:
 *   ilaç var                        → Yazıldı
 *   ilaç yok + talep işaretli       → Talep Edildi
 *   ilaç yok + talep yok            → Bekliyor
 */
export const PRESCRIPTION_STATUS = {
  written: { label: "Yazıldı", tone: "success" },
  requested: { label: "Talep Edildi", tone: "warning" },
  pending: { label: "Bekliyor", tone: "neutral" },
};

/** Bir tedavi kaydının reçete durum anahtarını döner. */
export function getPrescriptionStatus(treatment) {
  const meds = Array.isArray(treatment?.medications) ? treatment.medications : [];
  if (meds.length > 0) return "written";
  if (treatment?.prescriptionRequested) return "requested";
  return "pending";
}

export const diagnosisNames = (t) => (t?.diagnoses || []).map((d) => d.diagnosisName).filter(Boolean);
export const medicationNames = (t) =>
  (t?.medications || []).map((m) => m?.name || m?.medicine?.name).filter(Boolean);
